import { ErrorInfo, ReactNode, useState } from 'react';
import {
  ErrorBoundaryPropsWithRender,
  ErrorBoundary as ReactErrorBoundary,
} from 'react-error-boundary';

import { Box } from 'components/box';
import { Button } from 'components/button';
import { Flex } from 'components/flex';
import { Text } from 'components/text';
import { isDevMode } from 'utils';

interface ErrorBoundaryProps extends Pick<ErrorBoundaryPropsWithRender, 'onReset'> {
  children?: ReactNode;
}

/**
 * Standardized error boundary.
 */
export function ErrorBoundary(props: ErrorBoundaryProps) {
  const [, setErrorInfo] = useState<ErrorInfo | null>(null);

  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    if (isDevMode()) {
      setErrorInfo(errorInfo);
    }
  };

  return (
    <ReactErrorBoundary
      onError={handleError}
      fallbackRender={({ error, resetErrorBoundary }) => {
        return (
          <Flex align="center" justify="center" css={{ size: '100%' }}>
            <Box css={{ textAlign: 'center' }}>
              <Text as="div" variant="secondary" gutterBottom>
                Something has gone wrong.
              </Text>

              <Button onClick={() => resetErrorBoundary()}>Reset</Button>
            </Box>
          </Flex>
        );
      }}
      {...props}
    />
  );
}
